import React,{FC} from 'react'

interface ErrorComponentProps {
    message:string;
}

export const ErrorComponent:FC<ErrorComponentProps> = ({message}) => {
  return (
    <div style={{minHeight:'60px'}} className='d-flex justify-content-center'>
         <h6>{message}</h6>
    </div>
  )
}


